import * as React from 'react'
import {ACCOUNT_EVENTS, ACCOUNT_INFO, eventPageUrl, orderManagerPageUrl} from '../../../urls'
import BasicPage from '../../Page/BasicPage'
import OrderDetails from '../OrderDetails'
import OrderItems from '../OrderItems'
import {OrderStatus} from '../OrderStatus'
import {TransactionHistory} from '../TransactionHistory'
import {Breadcrumbs} from '../_components/Breadcrumbs'
import {Section} from '../_components/Section'
import {EventData, EventOrder} from '../types/eventData'
import {OrderData} from '../types/orderData'
import {getOrderTypeLabel} from '../utils'
import styles from './styles.module.scss'

interface Props {
  openErrorModal: () => void
  eventData: EventData
  orderData: OrderData
  eventOrder: EventOrder
  isParticipantUser: boolean
}

export const OrderOwnerContainer: React.FC<Props> = ({
  openErrorModal,
  eventData,
  orderData,
  eventOrder,
  isParticipantUser,
}) => (
  <BasicPage
    className={styles.container}
    title="Tuxedo and Suit rentals. Higher Quality, Lower Price"
    nonIndexable
  >
    <div className={styles.content}>
      <section className={styles.breadcrumbs}>
        <Breadcrumbs
          breadcrumbs={[
            {href: ACCOUNT_INFO, label: 'Account Settings'},
            {href: ACCOUNT_EVENTS, label: 'Upcoming Events'},
            {href: eventPageUrl(orderData.event.id), label: orderData.event.name},
            {
              href: orderManagerPageUrl(orderData.event.id, eventOrder.id),
              label: `My Order - ${orderData.event.eventTypeName}`,
            },
          ]}
        />
      </section>
      <Section className={styles.status} title="Order Status">
        <OrderStatus openErrorModal={openErrorModal} eventOrder={eventOrder} />
      </Section>
      <Section
        className={styles.items}
        title={getOrderTypeLabel(eventOrder)}
        data-testid="order-manager-order-items"
      >
        <OrderItems
          eventDate={eventData.event.date}
          eventOrder={eventOrder}
          isGroup={eventData.event.numMembers > 0}
          isParticipantUser={isParticipantUser}
        />
      </Section>
      <Section className={styles.details} title="Order Details">
        <OrderDetails orderData={orderData} eventOrder={eventOrder} eventData={eventData} />
      </Section>
      <Section className={styles.history} title="Transactions History">
        <TransactionHistory />
      </Section>
    </div>
  </BasicPage>
)
